import { render, staticRenderFns } from "./EmailFeedbackModal.vue?vue&type=template&id=6dc3c483&scoped=true&"
import script from "./EmailFeedbackModal.vue?vue&type=script&lang=ts&"
export * from "./EmailFeedbackModal.vue?vue&type=script&lang=ts&"
import style0 from "./EmailFeedbackModal.vue?vue&type=style&index=0&id=6dc3c483&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc3c483",
  null
  
)

export default component.exports